
import { Component, Vue, Ref } from 'vue-property-decorator'
import { CommonService } from '@/services'
import FullLoading from '@/components/full_loading/index.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

const status = {
    check: { check: 1, not: 0 },
    pass: { pass: 1, not: 0 }
}
// 检测状态
const checkSelectOptions = [
    { value: '', name: '全部' },
    { value: status.check.not, name: '未检测' },
    { value: status.check.check, name: '已检测' }
]
// 审核状态
const passSelectOptions = [
    { value: '', name: '全部' },
    { value: status.pass.not, name: '未通过' },
    { value: status.pass.pass, name: '已通过' }
]

@Component({
    name: 'MediaSplider',
    components: {
        FullLoading,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private isCheck = ''
    private isPass = ''
    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private isLoading = true
    private configList = []
    private status = status
    private checkSelectOptions = checkSelectOptions
    private passSelectOptions = passSelectOptions

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getSpliderList)
    }

    async mounted() {
        await this.getSpliderList()
        this.isLoading = false
    }

    // 获取爬虫配置列表
    private async getSpliderList() {
        const params = {
            is_check: this.isCheck,
            is_pass: this.isPass,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await CommonService.getSpiderConfigList(params)
        if (result.status === 200) {
            const { page_total: pTotal, list } = result.data
            this.pageTotal = pTotal
            this.configList = list.map((n: any) => ({ ...n, check: n.is_pass.id }))
        }
    }

    // 条件改变
    private async onFilterChnage() {
        this.pageIndex = 1
        this.isLoading = true
        await this.getSpliderList()
        this.isLoading = false
    }

    private onAction(type: 'detail' | 'reset' | 'delete', rowData: any) {
        switch (type) {
            case 'detail':
                return window.open(`/media/splider/${rowData.id}`)
            case 'reset':
                return this.resetConfig(rowData.id)
            case 'delete':
                return this.deleteConfig(rowData.id)
            default:
                return false
        }
    }

    // 重置
    private resetConfig(id: number | string) {
        this.$confirm('正在进行重置操作，是否确认?', '警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        })
            .then(async () => {
                const result = await CommonService.resetSpiderConfig({ id })
                if (result.status === 200) {
                    this.scrollEl.scrollToTop(async () => {
                        this.pageIndex = 1
                        this.isLoading = true
                        await this.getSpliderList()
                        this.isLoading = false
                    })
                    return this.$msuccess('重置成功')
                }
                this.$merror(result.message || '发生错误, 请稍后再试')
            })
            .catch(() => {})
    }

    // 删除
    private deleteConfig(id: number | string) {
        this.$confirm('正在进行删除操作，是否确认?', '警告', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        })
            .then(async () => {
                const result = await CommonService.deleteSpiderConfig({ id })
                if (result.status === 200) {
                    this.scrollEl.scrollToTop(async () => {
                        this.pageIndex = 1
                        this.isLoading = true
                        await this.getSpliderList()
                        this.isLoading = false
                    })
                    return this.$msuccess('删除成功')
                }
                this.$merror(result.message || '发生错误, 请稍后再试')
            })
            .catch(() => {})
    }

    /* 更新收录列表 */
    private async updateStatus(params: any) {
        const result = await CommonService.updateSpiderConfig(params)
        if (result.status === 200) {
            this.$message({ type: 'success', message: '设置成功' })
            return { status: true }
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
        return {
            status: false,
            message: result.message
        }
    }

    // 改变状态
    private async onStatusSelect(status: number, item: any) {
        this.$set(item, 'loading', true)
        const params = { id: item.id, is_pass: status }
        const result = await this.updateStatus(params)
        item.loading = false
        if (result.status) {
            item.is_pass.id = status
        } else {
            item.check = item.is_pass.id
        }
    }
}
